import numeral from "numeral";



export function fCurrency(number) {
  return numeral(number).format(Number.isInteger(number) ? "$0,0" : "$0,0.00");
}

export function fPercent(number) {
  return numeral(number / 100).format("0.0%");
}

export function fNumber(number) {
  return numeral(number).format();
}

export function fShortenNumber(number) {
  return numeral(number).format("0.00a").replace(".00", "");
}

export function fData(number) {
  return numeral(number).format("0.0 b");
}

export function fUSD(number) {
  const a = parseFloat(`${number}`);
  return (
    (a < 0 ? "-$" : "$") +
    Math.abs(a).toLocaleString("en-US", {
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
    })
  );
}

export function fLocaleString(number) {
  const a = parseFloat(`${number}`);
  return a.toLocaleString("en-US", {
    maximumFractionDigits: 0,
    minimumFractionDigits: 0,
  });
}

export function fLocaleStringUSD(number) {
  const a = parseFloat(`${number}`);
  return "$" + Math.abs(a).toLocaleString("en-US", {
    maximumFractionDigits: 0,
    minimumFractionDigits: 0,
  });
}
